export const AIFC_ONBOARDING_STATE_KEYS = {
	hasSeenAIFCSpotlight: 'aifc-onboarding:hasSeenAIFCSpotlight',
	isAIFCSpotlightActive: 'aifc-onboarding:isAIFCSpotlightActive',
	hasSeenWhiteboardSmartCreateSpotlight: 'aifc-onboarding:hasSeenWhiteboardSmartCreateSpotlight',
	hasSeenAIStreamingSpotlight: 'aifc-onboarding:hasSeenAIStreamingSpotlight',
	isAIFCChatSpotlightActive: 'aifc-onboarding:isAIFCChatSpotlightActive',
	hasSeenAIFCChatSpotlight: 'aifc-onboarding:hasSeenAIFCChatSpotlight',
} as const;

export const AIFCOnboardingKeys = [...Object.values(AIFC_ONBOARDING_STATE_KEYS)] as const;
